// extracted by mini-css-extract-plugin
module.exports = {"articleTitle":"_3sD1KQkfQm0YgOtwJE_J0q","title":"HzyvEuzgP_VSh7Xw58V2O","subTitle":"_2Oa7OaaKaHoZoOwmcO8XjH","description":"_33kbcQE2U9tk45SwVRArcJ"};